"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterimScreenOpenTimeoutPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const analytics_1 = require("@completeanatomy/analytics");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const hocs_1 = require("../../hocs");
const hooks_1 = require("../../hooks");
const Route_1 = require("../../router/Route");
const InterimScreenTemplate_1 = require("../../templates/InterimScreenTemplate/InterimScreenTemplate");
function InterimScreenOpenTimeoutPage() {
    const auth = (0, hooks_1.useAuth)();
    const environment = (0, hooks_1.useAuthType)();
    const accessToken = (0, hooks_1.useSelector)(authState => authState === null || authState === void 0 ? void 0 : authState.accessToken);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const analytics = (0, analytics_1.useAnalytics)();
    const onSignInClick = (0, react_1.useCallback)(() => {
        auth === null || auth === void 0 ? void 0 : auth.authenticate();
        analytics.log('GetStartedInterimPressed');
    }, [analytics, auth]);
    (0, react_1.useEffect)(() => {
        if (accessToken) {
            // Navigate to the next page
            navigate(`${Route_1.Route.Base}/${Route_1.Route.InterimScreen}/${Route_1.Route.InterimScreenProcess}`, {
                replace: true,
            });
        }
    }, [accessToken, environment, navigate]);
    return ((0, jsx_runtime_1.jsx)(InterimScreenTemplate_1.InterimScreenTemplate, { environment: environment, title: (0, i18n_1.Localized)(i18n_1.Strings.auth.interimScreen.authInProgressTimeout.title), subtitle: (0, i18n_1.Localized)(i18n_1.Strings.auth.interimScreen.authInProgressTimeout.description[environment]), canBeClosed: true, "data-e2e": 'InterimScreenOpenTimeoutPage_InterimScreenTemplate', children: (0, jsx_runtime_1.jsx)(GetStartedButton, { onClick: onSignInClick, "data-e2e": 'InterimScreenOpenTimeoutPage_GetStartedButton', children: (0, i18n_1.Localized)(i18n_1.Strings.auth.getStarted) }) }));
}
const InterimScreenOpenTimeoutPageWithProvider = (0, hocs_1.withAuthProvider)(InterimScreenOpenTimeoutPage);
exports.InterimScreenOpenTimeoutPage = InterimScreenOpenTimeoutPageWithProvider;
const GetStartedButton = (0, styled_components_1.default)(ui_1.PrimaryButton) `
  text-transform: uppercase;
  padding: 12px 16px;
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  border-radius: 6px;
  min-width: 224px;
`;
